
import { useNavigate } from 'react-router-dom';
import './fixed-button.css';

export const FixedButton = ({title, ...rest}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (rest?.link)
        {
            return navigate(rest.link);
        }
    }

    return (
        <div className="container fixed-btn-wrap d-flex justify-content-end align-items-center">
            <button {...rest} onClick={() => handleClick()}>{title}</button>
        </div>
    )
}